/**
 * Canonical origin for shareable public URLs (vendor page, follow links in My Website).
 * Defaults to production. Override with REACT_APP_PUBLIC_SITE_ORIGIN (e.g. http://localhost:3000) for local testing.
 */
export function getPublicSiteOrigin() {
  const raw =
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_PUBLIC_SITE_ORIGIN) || '';
  const trimmed = String(raw).trim().replace(/\/$/, '');
  return trimmed || 'https://fashdeck.com';
}
